import Image from "next/image";
import styles from "./TextImageCard.module.scss";

export default function TextImageCard({
  title,
  description,
  image,
  imageAlt,
  text,
  imageSide = "left",
}) {
  const titleElement = (
    <h3 className={`${styles.title} wn-text-image-card-title`}>{title}</h3>
  );
  return (
    <article
      className={`${styles.container} ${styles[imageSide]} wn-text-image-card-container`}
    >
      {title && imageSide === "top" && titleElement}
      <div className={`${styles.image} wn-text-image-card-image`}>
        {image && <Image src={image} alt={imageAlt ?? description} fill />}
      </div>
      <div className={`${styles.content} wn-text-image-card-content`}>
        {title && imageSide !== "top" && titleElement}
        {description && (
          <p className={`${styles.description} wn-text-image-card-description`}>
            {description}
          </p>
        )}
        {text && text}
      </div>
    </article>
  );
}
